import { Component, Input, OnInit } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { RestService } from '../rest.service';
import { UserService } from '../user.service';

@Component({
  selector: 'app-valoration',
  templateUrl: './valoration.page.html',
  styleUrls: ['./valoration.page.scss'],
})
export class ValorationPage implements OnInit {
  @Input() id_delivery: string;

  valoration = 0;
  valorationText;

  valorationProduct = 0;
  valorationProductText;

  constructor(
    private rest: RestService,
    private loading: LoadingController,
    public modal: ModalController,
    private user: UserService
  ) { }

  ngOnInit() {}

  valorate(){

    if ( this.valoration === 0){ this.user.generateToast('Valora del 1 al 5 el reparto'); }
    if ( this.valorationProduct === 0){ this.user.generateToast('Valora del 1 al 5 el producto'); } 

    this.rest.valoration(
      this.id_delivery,
      this.valoration,
      this.valorationText,
      this.valorationProduct,
      this.valorationProductText).subscribe(
      (data) => {
        this.user.generateToast(data['data']);
        this.modal.dismiss({
          'dismissed': true
        });
    },
    (error) => this.user.generateToast('Error al valorar') );
  }

  async setValorate(valoration){

    /* const loading = await this.loading.create(
      {
        message: 'Votando ...',
        duration: 1500
      });
    await loading.present(); */

    this.valoration = valoration;

    //loading.dismiss();
  }

  async setValorateProduct(valoration){ 
    /* const loading = await this.loading.create(
      {
        message: 'Votando ...',
        duration: 1500
      });
    await loading.present(); */
    this.valorationProduct = valoration;

    // loading.dismiss();
  }
}
